import actions from "./actions";
import mutations from "./mutations";

const state = {
  stepIndex: 1,
  companyList: [],
  showEdit: false,
  tempUser: [],
  tempPayment: [],
  tempBank: [],
  resultGrade: [],
  resultCostCenter: [],
  resultWorkLoc: [],
  tempOther: [],
  idDeleteUser: null,
  resultKaryawan: [],
  resultMasterKaryawan: [],
  resultCuti: [],
  searchKaryawan: [],
  tempJatahCuti: [],
  idCuti: null,
  resultEditCuti: [],
  resultCost: [],
  idcost: null,
  tempCost: [],
  resultCostEdit: [],
  resultMasterGrade: [],
  tempJobgrade: [],
  idJobgrade: [],
  res_jobgrade: [],
  resultMasterPosition: [],
  tempPosition: [],
  idPosition: [],
  idDepartemen: [],
  resPosition: [],
  resultRole: [],
  res_menus: [],
  tempROle: [],
  idROle: null,
  res_roleEdit: [],
  res_menu: [],
  resStore: [],
  exportKaryawan: [],
  resultMasterTax: [],
  resultMasterDepartemen: [],
  resDepartemen: [],
  tempTax: [],
  tempDepartemen: [],
  idTax: null,
  resTax: [],
  page: 1,
  search: "",
  master_career_transisiton: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
